export enum AxiosMethod {
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
  Get = 'GET',
}

export const defaultAxiosOptions = {
  manual: true,
  useCache: false,
};
